import React from 'react';

class App extends React.Component {
	constructor(props) {
		super(props);
		this.state = {
			msg   : null,
			}
		}
		loadData(cmd, id, data) {
			const requestOptions = {
			        method: 'POST',
				headers: { "Content-Type": "application/json", 'Access-Control-Allow-Origin': 'no-cors' },
			        body: JSON.stringify({'cmd':cmd,'id':id,'data':data}) };
			console.log(requestOptions);
			fetch("http://api.softwareexperts.com/" ,requestOptions)
			.then((response) => response.json())
			.then((res) => { console.log(res);
				if (res === undefined) {
					console.log("No Response from API: ");
				}
				else if (res["result"] !== undefined ) {
					this.setState({msg:res["result"]}); 
				}
				else {
				     console.log("Unknown object is loaded: ");
				     this.setState({error:res["error"]});
				}
			});
		}
		componentDidMount() {
			this.loadData("","","");
		}
		render() {
			const msg = this.state.msg;
			return (
				<div>
			           <h2>Message:  {msg} </h2>
				</div>
			);
		}
}

export default App;
